
<div tabindex="0">
  <button mat-button [routerLink]="['/users']" [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'">
    <!----
     <img src="../../assets/img/home.png" class="icon" width="30" height="34" />
   -->
    <mat-icon>home</mat-icon>
    <span>Home</span>

  </button>
  <button mat-button [routerLink]="['/users/ai-chat']" [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'">
    <mat-icon> chat</mat-icon>
    <!---
    <img src="../../assets/img/chat2.png" class="icon" width="30" height="34" />
   -->

    <span>AI Chat βeta</span>
  </button>


  <button mat-button [routerLink]="['/users/my-courses']" [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'">

      <!---
        <img src="../../assets/img/books.png" class="icon" width="25" height="30" style="color:blue;" />

         <mat-icon>school</mat-icon>
    -->

      <mat-icon>auto_stories</mat-icon>



      <span>My Courses</span>
  </button>


  <button mat-button [routerLink]="['/users/completed']" [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'">


      <!-----
       <img src="../../assets/img/boy.png" class="icon" width="25" height="30" />
      --->
      <mat-icon>workspace_premium</mat-icon>
      <span>Certifications</span>
  </button>



  <button mat-button [routerLink]="['/users/course-enroll']" [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'">

      <!--
          <img src="../../assets/img/enroll.png" class="icon" width="25" height="30" />
    --->
      <mat-icon>person_add</mat-icon>

      <span>Enroll</span>
  </button>


  <button mat-button [routerLink]="['/users/accounts']" [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'primary'">

      <!---
          <img src="../../assets/img/person.png" class="icon" width="25" height="30" />
    -->
      <mat-icon>person_outline</mat-icon>
      <span>Me</span>
  </button>



  <button mat-button (click)=notifi_alert() [routerLink]='' [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'" style="align-items:center;">

    <mat-icon *ngIf="clickEvent || getAlertClick.length == 0" style="align-content:center;color:dimgray;">notifications</mat-icon>
    <mat-icon *ngIf="!clickEvent && getAlertClick.length > 0" style="color:red;">notifications</mat-icon>
    <span>Notifications</span>
  </button>



  <!---
     <button mat-button [routerLink]="['/users/accounts']" [color]="red"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'">

    <mat-icon


    >group</mat-icon>
    <span>Accounts</span>
  </button>
    -->


  <button mat-button (click)=logout() [routerLink]='' [color]="color"
          (mouseover)="color = 'warn'"
          (mouseout)="color = 'accent'">
    <mat-icon matSuffix>

      logout
    </mat-icon>
    <span>Logout</span>
  </button>
</div>

